import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"]

  connect() {
    console.log("Element browser controller connected")
  }

  select(event) {
    console.log("Select called")
    const button = event.currentTarget
    const elementId = button.dataset.elementId
    const elementType = button.dataset.elementType
    const templateId = this.element.dataset.templateId

    console.log(`Fetching preview for ${elementType} ${elementId} in template ${templateId}`)

    fetch(`/mission_templates/${templateId}/preview_element/${elementType}/${elementId}`, {
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.text())
    .then(html => {
      console.log("Preview received", html.substring(0, 100))
      this.previewTarget.innerHTML = html
    })
    .catch(error => {
      console.error("Error fetching preview:", error)
    })
  }
} 